import clsx from 'clsx'
import { FC } from 'react'
import React from 'react'
import { useInView } from 'react-intersection-observer'

import s from './styles.module.scss'

import { Loader } from '../../loader'
import { HousesInformationsFieldsFragment } from '../../../../lib/graphql'

interface HouseSearchReachMoreProps {
  hasNextPage: boolean
  houses: HousesInformationsFieldsFragment[]
  onLoadMore: () => Promise<void>
  isFromTable?: boolean
}

export const HouseSearchReachMore: FC<HouseSearchReachMoreProps> = ({
  hasNextPage,
  houses,
  onLoadMore,
  isFromTable = false,
}) => {
  const { ref: refReachMore } = useInView({
    threshold: 0,
    onChange: (inView) => {
      if (inView) {
        onLoadMore()
      }
    },
  })

  return (
    <div ref={refReachMore}>
      {houses.length > 0 && hasNextPage && (
        <div
          className={clsx(s.container, { [s.containerTable]: isFromTable })}
          ref={refReachMore}
        >
          <Loader size={30} />
        </div>
      )}
    </div>
  )
}
